import { Currency, PlanType } from '~/codegen/graphql'
import { GetOrgMetadataDocument } from './use-org-metadata.generated'

export default function () {
  const { data, isFetching, isDone } = useQuery({
    query: GetOrgMetadataDocument,
    tags: ['org-metadata'],
  })

  const llmFeaturesEnabled = computed(() =>
    Boolean(data.value?.organization.llmFeaturesEnabled))
  const timezone = computed(() => data.value?.organization.timezone ?? '')
  const name = computed(() => data.value?.organization.name ?? '')
  const iconUrl = computed(() => data.value?.organization.iconUrl ?? null)
  const currency = computed(() => data.value?.organization.developerSalaries[0]?.currency ?? Currency.Usd)
  const trialDaysRemaining = computed(() =>
    data.value?.organization.planType === PlanType.Trial
      ? data.value?.organization.trialDaysRemaining
      : Number.MAX_SAFE_INTEGER,
  )

  return { llmFeaturesEnabled, timezone, name, iconUrl, isFetching, isDone, currency, trialDaysRemaining }
}
